// frontend/src/main.js - Corrected implementation

import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'

// Import Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Import FontAwesome
import '@fortawesome/fontawesome-free/css/all.min.css'

// Import custom styles (order matters - bootstrap overrides should come after bootstrap)
import '@/assets/css/dark-theme.css'
import '@/assets/css/bootstrap-override.css'

// Import translation files
import en from '@/locales/en.json'
import ja from '@/locales/ja.json'

// Log the translations for debugging
console.log('English translations loaded:', en);
console.log('Sample English translation:', en?.home?.hero?.title);

// Helper function to get the initial locale
function getInitialLocale() {
  // Check for locale in localStorage
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale) {
    return savedLocale
  }

  // Check for locale in URL path
  const pathSegments = window.location.pathname.split('/')
  if (pathSegments.length > 1) {
    const possibleLocale = pathSegments[1]
    if (['en', 'ja'].includes(possibleLocale)) {
      return possibleLocale
    }
  }

  // Check browser language
  const browserLang = navigator.language.split('-')[0]
  if (['en', 'ja'].includes(browserLang)) {
    return browserLang
  }

  // Default to English
  return 'en'
}

// Create i18n instance with the correct configuration for Vue 3
const i18n = createI18n({
  legacy: false,  // Using Composition API style
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    ja
  }
})

// Create app instance
const app = createApp(App)

// Add title mixin for page titles
app.mixin({
  methods: {
    setPageTitle(title) {
      document.title = title ? `${title} | CT Grid` : 'CT Grid'
    }
  }
})

// Use plugins - order matters, register i18n before mounting
app.use(i18n)
app.use(router)
app.use(store)

// Mount the app
app.mount('#app')

// Set HTML lang attribute based on the current locale
// legacy: false → need to use .value for Composition API
document.documentElement.setAttribute('lang', i18n.global.locale.value)

// Export i18n instance for easy use outside of Vue components
export { i18n }